import styled from 'styled-components'

// >= 1024px: tabs dọc bên trái, nội dung bên phải (UI mặc định).
// < 1024px : tabs chuyển sang ngang phía trên để màn hình không bị vỡ; tab nào
//            tràn sẽ gom vào dropdown "..." (more) của antd, hover để chọn.
//            Style tab ngang khớp với TabPane của Quản trị văn bản.
export const DocumentManagementTabLayout = styled.div`
  display: flex;

  @media (max-width: 1023px) {
    flex-direction: column;

    .custom-ant-vertical-tabs {
      &.hide-tab-content {
        margin-right: 0 !important;
        margin-bottom: 16px;
      }

      .ant-tabs-nav {
        margin: 0;
      }

      .ant-tabs-tab {
        min-height: 40px;
        width: auto;
        border: none;
        border-radius: 0;
        margin: 0 !important;
        padding: 8px 16px !important;
        justify-content: center;
        text-align: center !important;

        &:hover,
        &.ant-tabs-tab-active {
          background-color: transparent;
          border-color: transparent;
          color: #00b2ff;
        }
      }

      .ant-tabs-ink-bar {
        display: block !important;
      }
    }
  }
`

export const DocumentManagementTabContent = styled.div`
  width: 100%;
  min-width: 0;
  padding: 20px;
  border-radius: 16px;
  background-color: #f6f6f6;
  &.user-group-management {
    background-color: #fff;
  }
`
